import { useNavigate } from "react-router-dom"
import { ArrowLeft, Plus } from "lucide-react"
import CategoryTable from "./ui/CategoryTable"

const Categories = () => {
    const navigate = useNavigate()

    return (
        <>
            <button onClick={() => navigate(-1)} className="mt-5 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors font-inter text-sm">
                <ArrowLeft className="w-4 h-4" />
                Back
            </button>
            <div className="mt-6 flex items-center justify-between">
                <h2 className="text-xl md:text-2xl font-bold text-foreground font-inter">
                    Categories
                </h2>
                <button
                    onClick={() => navigate("/admin/inventory/new-category")}
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-2.5 bg-primary hover:bg-primary/90 text-primary-foreground text-sm font-medium font-inter rounded-xl transition-colors whitespace-nowrap"
                >
                    <Plus className="w-4 h-4" />
                    Add New Category
                </button>
            </div>
            <CategoryTable />
        </>
    )
}

export default Categories
